export enum PricingMethod {
  NORMAL = 'NORMAL',
  AVS = 'AVS',
  AI = 'AI',
  STUDENT = 'STUDENT'
}
